/**
 * Mapeamento de operadores de inglês para português
 * Baseado nos supported_operators retornados pelo backend em condition_definitions
 */

export const OPERATOR_MAP: Record<string, string> = {
  // Comparação básica
  equals: 'Igual a',
  not_equals: 'Diferente de',

  // Inclusão
  in: 'Está em',
  not_in: 'Não está em',

  // Texto
  contains: 'Contém',
  not_contains: 'Não contém',

  // Numérico
  greater_than: 'Maior que',
  less_than: 'Menor que',
  greater_than_or_equal: 'Maior ou igual a',
  less_than_or_equal: 'Menor ou igual a',

  // Data
  before: 'Antes de',
  after: 'Depois de',
  between: 'Entre',
};

/**
 * Converte operador do formato do backend ('equals') para português
 * Remove aspas simples se existirem: 'equals' → equals → Igual a
 * Também converte maiúsculas: EQUALS → equals → Igual a
 */
export const mapOperatorToPortuguese = (operator: string): string => {
  const cleanOperator = operator.replace(/'/g, '').toLowerCase(); // Remove aspas e lowercase
  return OPERATOR_MAP[cleanOperator] || operator; // Retorna original se não encontrar
};

/**
 * Converte operador de português para formato do backend
 */
export const mapOperatorToEnglish = (operatorPT: string): string => {
  const entry = Object.entries(OPERATOR_MAP).find(([_, pt]) => pt === operatorPT);
  return entry ? entry[0] : operatorPT;
};

/**
 * Converte lista de operadores do backend para formato UI com labels em português
 * Suporta operadores com aspas ('equals') e sem aspas (equals)
 * Retorna value em MAIÚSCULAS para compatibilidade com Operator type
 */
export const mapOperatorsFromBackend = (
  supportedOperators: string[]
): Array<{ value: string; label: string }> => {
  return supportedOperators.map(op => {
    const cleanOp = op.replace(/'/g, '').toLowerCase(); // Remove aspas e lowercase
    const uppercaseOp = cleanOp.toUpperCase(); // Para o Operator type (EQUALS, IN, etc)

    return {
      value: uppercaseOp, // EQUALS (para type Operator)
      label: OPERATOR_MAP[cleanOp] || op, // "Igual a" (para usuário)
    };
  });
};
